module.exports = __webpack_public_path__ + "f42dd035c1317ef0c275dac463493e78.png";